import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { HarpLoginService } from '@login/services/harp-login.service';
import { NavigationService } from '@login/services/navigation.service';
import { constant } from '@login/resources/constant';
import { SessionService } from '@shared/services/session.service';

import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CheckSessionGuard implements CanActivate {
  constructor(
    private harpLoginService: HarpLoginService,
    private navigationService: NavigationService,
    private cookieService: CookieService,
    private sessionService: SessionService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise(async resolve => {
      try {
        const sessionExist = await this.harpLoginService.doesSessionExist(); // Okta session
        console.log('sessionExist log: ', sessionExist);
        if (!sessionExist) {
          // okta session does not exist
          return resolve(true);
        }
      } catch (err) {
        return resolve(true);
      }

      const session: any = await this.harpLoginService.getSession();

      if (!session) {
        return resolve(true);
      }

      try {
        const harpToken = this.cookieService.get('harp_token_accessible');

        const sessionInfo: any = await this.harpLoginService
          // .authenticateSessionHsid({ hsid: session.id })  // old way
          .authenticateSessionHsid({ harp_token: harpToken }) // new way
          .toPromise();

        if (sessionInfo?.authstatus !== constant.sessionExist) {
          // if harp auth session does not exist, destroy okta session and display login screen
          console.log(
            'harp auth session is invalid, destroying all sessions: ',
            sessionInfo,
          );
          await this.harpLoginService.logout();
          return resolve(true);
        }

        if (!window.location.search) {
          this.navigationService.goToHomepage();
          return false;
        }

        await this.harpLoginService.navigateToAdoHomePage();
      } catch (err) {
        return resolve(true);
      }
    });
  }
}
